import { defineStore } from 'pinia'
import { ref } from 'vue'

// 用户信息接口
interface UserInfo {
  id: number
  nickname: string
  avatar?: string
  auths: string  // 权限字符串，以逗号分隔
  [key: string]: any
}

export const useUserStore = defineStore('user', () => {
  const token = ref<string | null>(localStorage.getItem('token'))
  const userInfo = ref<UserInfo | null>(JSON.parse(localStorage.getItem('userInfo') || 'null'))

  // 设置 token
  function setToken(newToken: string) {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }

  // 设置用户信息
  function setUserInfo(info: UserInfo) {
    userInfo.value = info
    localStorage.setItem('userInfo', JSON.stringify(info))
  }

  // 清除用户信息
  function clearUserInfo() {
    token.value = null
    userInfo.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }

  // 检查是否有特定权限
  function hasPermission(permission: string): boolean {
    if (!userInfo.value?.auths) return false
    // auths 可能是逗号分隔字符串，也可能是数组（iframe 嵌入场景），兼容两种格式
    const auths = userInfo.value.auths
    const authList = Array.isArray(auths)
      ? auths
      : String(auths).split(',').map((auth: string) => auth.trim())
    return authList.includes(permission)
  }

  return {
    token,
    userInfo,
    setToken,
    setUserInfo,
    clearUserInfo,
    hasPermission
  }
})

